<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '因子'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    top="10vh"
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="110px" :rules="rules">
      <el-form-item label="是否自定义" prop="IsCustomOrNot">
        <el-switch v-model="item.IsCustomOrNot"></el-switch>
      </el-form-item>
      <el-form-item label="编码" prop="Code">
        <el-input v-model.trim="item.Code" placeholder="请输入编码"></el-input>
      </el-form-item>
      <el-form-item label="中文名称" prop="Name">
        <el-input
          v-model.trim="item.Name"
          placeholder="请输入中文名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="原编码" prop="OldCode">
        <el-input
          v-model.trim="item.OldCode"
          placeholder="请输入原编码"
        ></el-input>
      </el-form-item>
      <el-form-item label="因子类型" prop="DciCategoryID">
        <select2
          style="width: 100%"
          v-model="item.DciCategoryID"
          url="basic?type=businesstype"
          :clearable="false"
          placeholder="请选择因子分类"
          :emptyValue="0"
          :currentList="currentDciCategory"
        ></select2>
      </el-form-item>
      <el-form-item label="化学符号学号" prop="CASNumber">
        <el-input
          v-model.trim="item.CASNumber"
          placeholder="请输入化学符号学号"
        ></el-input>
      </el-form-item>
      <el-form-item label="缺省数据类型" prop="DefaultDataType">
        <el-input
          v-model.trim="item.DefaultDataType"
          placeholder="请输入缺省数据类型"
        ></el-input>
      </el-form-item>
      <el-form-item label="计量单位" prop="MeasureUnitID">
        <select2
          style="width: 100%"
          v-model="item.MeasureUnitID"
          url="measureunit"
          :clearable="false"
          placeholder="请选择计量单位"
          :emptyValue="0"
          :currentList="currentMeasureUnit"
        ></select2>
      </el-form-item>
      <el-form-item label="单位(浓度)" prop="Unit">
        <el-input
          v-model.trim="item.Unit"
          placeholder="请输入单位(浓度)"
        ></el-input>
      </el-form-item>
      <el-form-item label="单位(排放量)" prop="UnitCou">
        <el-input
          v-model.trim="item.UnitCou"
          placeholder="请输入单位(排放量)"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
    deviceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      item: {},
      rules: {
        Code: [{ required: true, message: "编码不能为空", trigger: "blur" }],
        Name: [
          { required: true, message: "中文名称不能为空", trigger: "blur" },
        ],
        // OldCode: [
        //   { required: true, message: "原编码不能为空", trigger: "blur" },
        // ],
        DciCategoryID: [
          { required: true, message: "因子类型不能为空", trigger: "blur" },
        ],
        MeasureUnitID: [
          { required: true, message: "计量单位不能为空", trigger: "blur" },
        ],
        DefaultDataType: [
          { required: true, message: "缺省数据类型不能为空", trigger: "blur" },
          {
            pattern: /N\d+\.\d*$/,
            message: "格式不正确,如：N4.2",
            trigger: "blur",
          },
        ],
      },
      submitting: false,
      currentMeasureUnit: [],
      currentDciCategory: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  created() {},
  methods: {
    onOpen() {
      this.item = _.clone(this.value);
      if (this.value.ID) {
        //计量单位
        if (this.value.MeasureUnit) {
          this.currentMeasureUnit = [
            { ID: this.value.MeasureUnitID, Name: this.value.MeasureUnit.Name },
          ];
        }
        //因子类型
        if (this.value.DciCategory) {
          this.currentDciCategory = [
            {
              ID: this.value.DciCategoryID,
              Name: this.value.DciCategory.Name,
            },
          ];
        }
      }
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();

      this.currentMeasureUnit = [];
      this.currentDciCategory = [];
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios
          .request({
            url: this.item.ID ? `dcifactor/${itemData.ID}` : "dcifactor",
            method: itemData.ID ? "put" : "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success(itemData.ID ? "编辑成功" : "新增成功");
            this.submitting = false;
            this.$emit(itemData.ID ? "form:updated" : "form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit(itemData.ID ? "form:updated" : "form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },
  },
};
</script>
